// MapIcon
const MapIcon = ({width = 24,height = 24}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9844 21.53C11.9844 21.53 19.9844 16.3017 19.9844 10.2573C19.9844 5.94718 16.4027 2.45312 11.9844 2.45312C7.5661 2.45312 3.98438 5.94718 3.98438 10.2573C3.98438 16.3017 11.9844 21.53 11.9844 21.53Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M12 13.2227C13.5188 13.2227 14.75 11.9914 14.75 10.4727C14.75 8.95389 13.5188 7.72266 12 7.72266C10.4812 7.72266 9.25 8.95389 9.25 10.4727C9.25 11.9914 10.4812 13.2227 12 13.2227Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default MapIcon
